<div class="grid-form-control" [class.required]="selfAsFormControl.invalid">
    <form [formGroup]="form">
        @if (isDropdown) {
            @if (isLoading) {
                <mat-spinner diameter="20"></mat-spinner>
            }
            @else {
                <select
                    #entryRef
                    [formControlName]="entry?.formControlAttributes?.formControlName"
                    [name]="entry?.formControlAttributes?.formControlName"
                    (blur)="onBlur()"
                    class="form-select">
                    @for (option of dropdownOptions; track option.value) {
                        <option [ngValue]="option.value">{{ option.label }}</option>
                    }
                </select>
            }
        }
        @else {
            <input matInput
                #entryRef
                [formControlName]="entry?.formControlAttributes?.formControlName"
                type="entry?.inputAttributes?.type || 'text'"
                [name]="entry?.formControlAttributes?.formControlName"
                placeholder="{{ entry?.inputAttributes?.placeholder }}"
                (blur)="onBlur()"
                [ptlMask]="entryMask"
                />
        }
    </form>
</div>